module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('slide', {
    attrs: {
      "from": "bottom",
      "show": _vm.show
    }
  }, [_c('select-area', {
    on: {
      "on-cancel": _vm.cancel,
      "on-confirm": _vm.confirm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a871086a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/plugins/select-area/index.vue
// module id = 269
// module chunks = 2 3 4 7 8 11 12 18 65 68